<template>
  <v-container fluid class="mt-3">
        <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row align="center" no-gutters>
            <v-col v-if="query.userid!=null" cols="12" md="3" class="d-flex justify-space-between justify-md-start">
                <div>
                  <v-avatar v-if="users.find(user=>user._id == query.userid)['userimage']!==''" size="40">
                    <img v-bind:src="users.find(user=>user._id == query.userid)['userimage']" alt="">
                  </v-avatar>
                  <v-avatar v-else color="warning" size="40">
                    <span class="white--text headline">{{ users.find(user=>user._id == query.userid)['username'][0].toUpperCase() }}</span>
                  </v-avatar>
                  <span style="margin-left:15px">{{ users.find(user=>user._id == query.userid)['username'] }}</span>
                </div>
            </v-col>
            <v-col cols="12" md="3" class="d-flex justify-space-between justify-md-start">
              <div>
                <div style="display: block; margin: 0;" v-if="query.regionid!=null"><span><b>Region:</b> {{ regions.find(region=>region._id == query.regionid)['regionname'] }}</span></div> 
                <div style="display: block; margin: 0;" v-if="query.townshipid!=null"><span><b>Township:</b> {{ townships.find(town=>town._id == query.townshipid)['townshipname'] }}</span></div> 
                <div style="display: block; margin: 0;" v-if="query.startdate!=null || query.enddate!=null"><b>Date Range:</b> {{ query.startdate }} - {{ query.enddate }}</div> 
              </div>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="12" md="3" class="d-flex justify-space-between justify-md-end">
              <v-btn 
                color="success" 
                class="button-shadow mr-3"
                @click="findGeolocationDialog = true"
              >
                <v-icon class="mr-2">mdi-account-search</v-icon>
                Find
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text class="pa-0 rounded overflow-hidden">
            <div class="mapContainer" v-bind:style="geolocations.length>0 ? 'height: 700px' : 'height: 50px'">
              <GmapMap v-if="geolocations.length>0"
                :center="{lat: median.lat, lng: median.lng}"
                :zoom="13"
                style="width: 100%; height: inherit"
              >
              <GmapMarker
                  v-for="(location, index) in geolocations"  
                  :key="index"
                  :position="{lat: parseFloat(location.lat), lng: parseFloat(location.lng)}"
                  :label="index.toString()"
                  :clickable="true"
                  :draggable="false"
                  @click="openInfoWindowTemplate(location)"
              />
                <gmap-info-window
                    :options="{
                      maxWidth: 300,
                      pixelOffset: { width: 0, height: -35 }
                    }"
                    :position="infoWindow.position"
                    :opened="infoWindow.open"
                    @closeclick="infoWindow.open=false">
                    <div v-html="infoWindow.template"></div>
                </gmap-info-window>
                
              </GmapMap>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
        <v-row justify="center">
    <v-dialog
      v-model="findGeolocationDialog"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Find Geolocation</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  :items="users.filter(x=>x.userstatus=='Active').map(x => {
                            return {text: x.username, value: x._id};
                          })"
                  v-model="query.userid"
                  label="Sales Rep"
                  required
                ></v-select>
              </v-col>

              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_startdate"
                          v-model="menu_startdate"
                          :close-on-content-click="false"
                          :return-value.sync="query.startdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.startdate"
                              label="Start Date"
                              v-bind="attrs"
                              v-bind:value="query.startdate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter start date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.startdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_startdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_startdate.save(query.startdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                        <v-menu
                          ref="menu_enddate"
                          v-model="menu_enddate"
                          :close-on-content-click="false"
                          :return-value.sync="query.enddate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="query.enddate"
                              label="End Date"
                              v-bind="attrs"
                              v-bind:value="query.enddate"
                              v-on="on"
                              persistent-hint
                              single-line hint="Please enter end date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="query.enddate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu_enddate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu_enddate.save(query.enddate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="query = {}"
          >
            Clear
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findGeolocationDialog = false"
          >
            Close
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="findGeolocation"
          >
            Find
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'GoogleMap',
    data() {
    return {
      infoWindow: {
          position: {lat: 0, lng: 0},
          open: false,
          template: ''
      },
      findGeolocationDialog: false,
      query: {},
      median: {lat: 0, lng: 0},
      geolocations: [],
      menu_startdate: null,
      menu_enddate: null,
    }
  },
  computed: {
    ...mapState('Geolocation', ['isDeleting', 'isReceiving']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
  },
  methods: {
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    ...mapActions('Geolocation', ["getGeolocationsByUser"]),

    async findGeolocation(){
      console.log('query', this.query);
      this.findGeolocationDialog = false;
      let result = await this.getGeolocationsByUser(this.query);
      this.geolocations = result;
      this.median = this.findMedian();
      console.log(this.geolocations);
      console.log(this.median);
    },
    openInfoWindowTemplate(item) {
      console.log(item)
      this.infoWindow.open = true;
      this.infoWindow.position = { lat: parseFloat(item.lat), lng: parseFloat(item.lng) }
      this.infoWindow.template = `<img src="${item.userimage}" width="200">
                                  <p style="margin: 0"><b>${item.username}</b></p>
                                  <p style="margin-top: 0; margin-bottom: 5"><b>${new Date(item.dateutc).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' })}</b></p>
                                  <p style="margin: 0">Accuracy: ${parseFloat(item.accuracy).toFixed(2)}</p>
                                  <p style="margin: 0">Altitude: ${parseFloat(item.altitude).toFixed(2)}</p>
                                  <p style="margin: 0">Bearing: ${item.bearing}</p>
                                  <p style="margin: 0">Speed: ${item.speed}</p>
                                  <br>`
      console.log(this.infoWindow);
      this.infoWindow.open = true
    },
    findMedian(){
      let lats = this.geolocations.map(location=>parseFloat(location.lat));
      let lngs = this.geolocations.map(location=>parseFloat(location.lng));
      lats.sort();
      lngs.sort();
      return {lat: lats[parseInt(lats.length/2)], lng: lngs[parseInt(lngs.length/2)]}
    }
  },
  created () {
    if(this.users.length==0) this.getUsersRequest();
    if(this.regions.length==0) this.getRegionsRequest();
    if(this.townships.length==0) this.getTownshipsRequest();
  },
};
</script>

<style src="./geolocation.scss" lang="scss" scoped/>
